var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "emd-container _content_spaced _footer_spaced" },
    [
      _c("div", { staticClass: "emd-container__content" }, [
        _vm.isEmpty
          ? _c(
              "div",
              {
                staticClass:
                  "eu-display_flex eu-column eu-justify_space-between",
              },
              [
                _vm._m(0),
                _c("div", { staticClass: "el-chunk eu-pa_3" }, [
                  _c("i", {
                    staticClass:
                      "emd-text _size_page _color_subtle uil uil-exclamation-triangle",
                  }),
                  _c(
                    "p",
                    {
                      staticClass:
                        "emd-text _size_section _color_nonessential eu-mt_3",
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("noEnterprises")) + " ")]
                  ),
                ]),
              ]
            )
          : _c(
              "div",
              {
                staticClass:
                  "eu-display_flex eu-column eu-justify_space-between",
              },
              [
                _vm.isMundiScope
                  ? _c(
                      "div",
                      {
                        staticClass: "emd-highlight-tag",
                        class: { _active: _vm.permission.is_default },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "emd-tooltip",
                            attrs: {
                              "data-tooltip": _vm.permission.is_default
                                ? _vm.$t("primaryAccess")
                                : _vm.$t("setAsPrimary"),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.changeDefault(_vm.permission)
                              },
                            },
                          },
                          [_c("i", { staticClass: "uil uil-star" })]
                        ),
                      ]
                    )
                  : _vm._e(),
                _c("div", { staticClass: "el-chunk" }, [
                  _c("div", { staticClass: "eu-pb_1 eu-pr_1" }, [
                    _vm.isMundiScope
                      ? _c(
                          "a",
                          {
                            staticClass:
                              "emd-text _type_caption _size_section emd-link",
                            attrs: { href: _vm.urlCompany },
                          },
                          [_vm._v(_vm._s(_vm.permission.name))]
                        )
                      : _c(
                          "p",
                          {
                            staticClass: "emd-text _type_caption _size_section",
                          },
                          [_vm._v(" " + _vm._s(_vm.permission.name) + " ")]
                        ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "emd-copy" },
                    [_c("emd-copy", { attrs: { item: _vm.permission.id } })],
                    1
                  ),
                ]),
                _vm.permission.account
                  ? _c("div", { staticClass: "el-chunk" }, [
                      _c(
                        "p",
                        {
                          staticClass:
                            "emd-text _type_label _color_nonessential _size_tiny",
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("defaultAccount")) + " ")]
                      ),
                      _c("p", { staticClass: "emd-text _color_default" }, [
                        _vm._v(_vm._s(_vm.permission.account.name)),
                      ]),
                    ])
                  : _vm._e(),
              ]
            ),
      ]),
      !_vm.isEmpty
        ? _c("div", { staticClass: "emd-container__footer" }, [
            _c("div", { staticClass: "eu-flex" }, [
              _vm.isMundiScope
                ? _c("div", { staticClass: "eu-flex-item eu-basis_0" }, [
                    _c(
                      "p",
                      {
                        staticClass:
                          "emd-text _type_label _color_nonessential _size_tiny",
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("permission")) + " ")]
                    ),
                    _c("p", { staticClass: "emd-badge _color_info" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.permission.type
                              ? _vm.permission.type.value
                              : _vm.permission.role.value
                          ) +
                          " "
                      ),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { staticClass: "eu-flex" }, [
                _c("div", { staticClass: "eu-flex-item eu-basis_0" }, [
                  _c(
                    "p",
                    {
                      staticClass:
                        "emd-text _type_label _color_nonessential _size_tiny",
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("version")) + " ")]
                  ),
                  _c("div", { staticClass: "emd-badge _color_info" }, [
                    _vm._v(
                      " " + _vm._s(_vm.isMundiScope ? "2.0" : "1.0") + " "
                    ),
                  ]),
                ]),
              ]),
            ]),
            (_vm.permissionIsEnabled("settings.info:edit") ||
              _vm.permissionIsEnabled("settings.general_data:edit") ||
              _vm.permissionIsEnabled("settings.functionalities:edit")) &&
            _vm.isMundiScope
              ? _c(
                  "div",
                  { staticClass: "eu-pt_2" },
                  [
                    _c(
                      "emd-button",
                      {
                        attrs: { type: "text", color: "primary", block: "" },
                        on: {
                          click: function ($event) {
                            return _vm.urlCompanyConfiguration(
                              _vm.permission.id
                            )
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "uil uil-external-link-alt" }),
                        _vm._v(" " + _vm._s(_vm.$t("configCompany")) + " "),
                      ]
                    ),
                  ],
                  1
                )
              : !_vm.isMundiScope
              ? _c(
                  "div",
                  { staticClass: "eu-align-self_end" },
                  [
                    _c(
                      "emd-button",
                      {
                        attrs: { disabled: _vm.isActive, color: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.redirect("" + _vm.dashAdmin)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("dashAdmin")) + " ")]
                    ),
                    _c(
                      "emd-button",
                      {
                        attrs: { color: "secondary" },
                        on: {
                          click: function ($event) {
                            return _vm.redirect("" + _vm.impersonate)
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("impersonate")) + " ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "emd-highlight-tag",
        staticStyle: { "pointer-events": "none" },
      },
      [
        _c("span", { staticClass: "emd-tooltip" }, [
          _c("i", { staticClass: "uil uil-star" }),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }